module.exports = __webpack_public_path__ + "img/LTC-ability-02.7c94b7de.png";